import { render, staticRenderFns } from "./SelectedGroupTagVirtualList.vue?vue&type=template&id=b4b187da&"
import script from "./SelectedGroupTagVirtualList.vue?vue&type=script&lang=ts&"
export * from "./SelectedGroupTagVirtualList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports